<template>
    <div class="profile-thumbnail" :data-testid="`profiles-grid-thumbnail-${index}`">
        <svg width="0" height="0">
            <defs>
                <clipPath id="thumb-svg"><path :d="svgPath" /></clipPath>
            </defs>
        </svg>

        <NuxtLink v-if="isFilled.link(profile.link) && profile.link.url" v-slot="{href, navigate}" :to="$withLocalePrefix(profile.link?.url)" custom>
            <div @click="navigate">
                <a :href="href!" :data-testid="`profiles-grid-thumbnail-${index}-link`">
                    <div class="profile-thumbnail__image">
                        <PrismicImage :field="profile.image" :alt="profile.image.alt" :data-testid="`profiles-grid-thumbnail-${index}-image`" />
                    </div>
                    <div class="profile-thumbnail__info">
                        <div class="profile-thumbnail__name" :data-testid="`profiles-grid-thumbnail-${index}-name`">{{ profile.name }}</div>
                        <p class="profile-thumbnail__job" :data-testid="`profiles-grid-thumbnail-${index}-job`">{{ profile.job }}</p>
                        <p class="profile-thumbnail__location" :data-testid="`profiles-grid-thumbnail-${index}-location`">{{ profile.location }}</p>
                    </div>
                </a>
            </div>
        </NuxtLink>
    </div>
</template>

<script setup lang="ts">
    import {isFilled} from '@prismicio/helpers';
    import {PrismicImage} from '@prismicio/vue';

    import type {ProfilesSliceProfilesGridPrimaryProfilesItem} from '@prismicio-types';

    defineProps<{profile: ProfilesSliceProfilesGridPrimaryProfilesItem; index: number}>();

    const svgPath =
        'M 78.985 198 C 147.664 198 157.97 146.246 157.97 105.909 L 157.97 92.093 C 157.958 51.755 147.651 0 78.985 0 C 10.306 0 0 51.755 0 92.093 L 0 105.909 C 0 146.246 10.306 198 78.985 198 Z';
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    $image_width: 158px;
    $image_height: 198px;
    $transition_params: 0.4s ease-out;

    .profile-thumbnail {
        text-align: center;
        margin-bottom: var(--joy-core-spacing-10);
        user-select: none;

        p {
            margin-top: var(--joy-core-spacing-1);
            font-size: var(--joy-font-size-primary-400);
            transition: color $transition_params;
            color: var(--joy-color-neutral-40);
        }
        &__image {
            overflow: hidden;
            width: $image_width;
            height: $image_height;
            clip-path: url(#thumb-svg);
            display: inline-block;
            margin: 0 auto var(--joy-core-spacing-4);
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform $transition_params;
        }
        &__name {
            font-family: var(--joy-font-family-title);
            color: var(--joy-color-text-default);
            font-size: var(--joy-font-size-secondary-200);
            line-height: var(--joy-line-height-small);
            transition: color $transition_params;
        }
        &__job {
            font-weight: var(--joy-font-weight-bold);
        }
        a:hover {
            img {
                transform: scale(1.05);
            }
            div,
            p {
                color: var(--joy-color-neutral-70);
            }
        }
    }
</style>
